module.exports = __webpack_public_path__ + "img/full3-min.81ed35b4.png";